import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AlertRuleView } from "./AlertRuleView";
import { AlertRuleViewStore } from "../../store/AlertRuleViewStore";
import { useStore } from "../../../../hooks";

export const AlertRuleViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/alertRule/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AlertRuleViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AlertRuleView alertRuleViewStore={store} />
      </PageLayout>
    </div>
  );
});
